import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'config/axiosBaseQuery';
import { endpoints } from 'config/api';
import {
  ILeadTemplate,
  LeadFormsResponse,
  LeadFormResponse,
  CreateLeadFormResponse,
  UpdateLeadFormResponse,
  DeleteLeadFormResponse,
  CreateLeadFormDto,
  UpdateLeadFormDto,
} from './leadsTemplatesTypes';

export const leadsTemplatesApi = createApi({
  reducerPath: 'leadsTemplatesApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['LeadTemplates', 'LeadTemplate'],
  endpoints: (builder) => ({
    fetchLeadTemplates: builder.query<ILeadTemplate[], void>({
      query: () => ({
        url: endpoints.leadsTemplates.base,
        method: 'GET',
      }),
      transformResponse: (response: LeadFormsResponse) => response.data,
      providesTags: ['LeadTemplates'],
    }),

    getLeadTemplate: builder.query<ILeadTemplate, string>({
      query: (id) => ({
        url: `${endpoints.leadsTemplates.base}/${id}`,
        method: 'GET',
      }),
      transformResponse: (response: LeadFormResponse) => response.data,
      providesTags: (_res, _err, id) => [{ type: 'LeadTemplate', id }],
    }),

    createLeadTemplate: builder.mutation<ILeadTemplate, CreateLeadFormDto>({
      query: (data) => ({
        url: endpoints.leadsTemplates.base,
        method: 'POST',
        data,
      }),
      transformResponse: (response: CreateLeadFormResponse) => response.data,
      invalidatesTags: ['LeadTemplates'],
    }),

    updateLeadTemplate: builder.mutation<ILeadTemplate, { id: string; data: UpdateLeadFormDto }>({
      query: ({ id, data }) => ({
        url: `${endpoints.leadsTemplates.base}/${id}`,
        method: 'PUT',
        data,
      }),
      transformResponse: (response: UpdateLeadFormResponse) => response.data,
      invalidatesTags: (_res, _err, { id }) => [
        'LeadTemplates',
        { type: 'LeadTemplate', id },
      ],
    }),

    deleteLeadTemplate: builder.mutation<DeleteLeadFormResponse, string>({
      query: (id) => ({
        url: `${endpoints.leadsTemplates.base}/${id}`,
        method: 'DELETE',
      }),
      transformResponse: (response: DeleteLeadFormResponse) => response,
      invalidatesTags: ['LeadTemplates'],
    }),
  }),
});

export const {
  useFetchLeadTemplatesQuery,
  useGetLeadTemplateQuery,
  useCreateLeadTemplateMutation,
  useUpdateLeadTemplateMutation,
  useDeleteLeadTemplateMutation,
} = leadsTemplatesApi;
